export default __webpack_public_path__ + "static/media/angbao-bonus.11fe18c7.webp";